import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getStoredMediaInfo = (classId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_STORED_MEDIA_INFO(classId)
  );
};

export default getStoredMediaInfo;
